module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      },
      on: {
        "click": function($event) {
          return _vm.refreshTab(tabitem)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-container', {
    key: _vm.pageRefKey,
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.lAction === 'view') ? _c('v-tab-item', {
    key: 0,
    attrs: {
      "value": "tab-0"
    }
  }, [_c('v-layout', {
    staticClass: "pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.attTab),
      callback: function($$v) {
        _vm.attTab = $$v
      },
      expression: "attTab"
    }
  }, _vm._l((_vm.attTabItems), function(attitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      },
      on: {
        "click": function($event) {
          return _vm.loadAttSummary(attitem, _vm.filter.billable)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(attitem) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), (_vm.attTab === 'tab-3') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodFrom",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgPeriodFrom),
      callback: function($$v) {
        _vm.dlgPeriodFrom = $$v
      },
      expression: "dlgPeriodFrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodFrom = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodFrom.save(_vm.filter.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodTo",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgPeriodTo),
      callback: function($$v) {
        _vm.dlgPeriodTo = $$v
      },
      expression: "dlgPeriodTo"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodTo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodTo.save(_vm.filter.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadAttSummary('month/period', _vm.filter.billable)
      }
    }
  }, [_vm._v("Go")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.attTab !== 'tab-3' && _vm.$vuetify.breakpoint.smAndUp) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vendor filter",
      "items": _vm.vendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "placeholder": "All",
      "clearable": "",
      "chips": "",
      "multiple": "",
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadAttSummary(_vm.filter.current_period, _vm.filter.billable)
      }
    },
    model: {
      value: (_vm.filter.vendor_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "vendor_list", $$v)
      },
      expression: "filter.vendor_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'mt-3' : 'mt-0',
    on: {
      "click": function($event) {
        return _vm.showAttLog()
      }
    }
  }, [_vm._v("View " + _vm._s(_vm.filter.current_period) + "'s Log")])], 1), _vm._v(" "), (_vm.shifts.length > 0) ? _c('v-flex', {
    staticClass: "py-2 text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.filter.billable === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadAttSummary(_vm.filter.current_period, chip)
        }
      }
    }, [_vm._v("\n            " + _vm._s(chip) + "\n          ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.shifts), function(shift, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "text-xs-center",
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('v-card', {
      class: shift.shift_id === _vm.lCurrentShiftId ? 'active-shift' : '',
      nativeOn: {
        "click": function($event) {
          return _vm.showShift(shift.shift_id)
        }
      }
    }, [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v(_vm._s(_vm.$vuetify.breakpoint.smAndUp ? shift.shift_abbr : shift.shift_abbr.substring(0, 10)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showShiftDet(shift.shift_id)
        }
      }
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-2"
    }, [_c('v-layout', {
      staticClass: "subheading",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "display-1"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].attAve >= 0 ? (_vm.shiftSummary[shift.shift_id].attAve + '%') : '-'))]), _vm._v(" "), (_vm.shiftSummary[shift.shift_id].attAve > 100) ? _c('div', {
      staticClass: "caption grey--text"
    }, [_vm._v("\n                  It is more than 100% due to SBy/OT\n                ")]) : _vm._e()]), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-1"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "black--text lighten-2"
    }, [_vm._v("\n                  Present\n                ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "display-1"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totPresent))]), _vm._v("/"), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totStaff))])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        Leave/Ab\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totAbsent + _vm.shiftSummary[shift.shift_id].totLeave))])])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        Weekoff\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totWO))])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        SBy/OT\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totOT))])])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        " + _vm._s((_vm.$vuetify.breakpoint.smAndUp ? 'Pending' : 'Pen'))), _c('span', {
      staticClass: "caption"
    }, [_vm._v(" In|Out")])]), _vm._v(" "), _c('div', [_c('span', {
      class: _vm.shiftSummary[shift.shift_id].totNotYetIn ? 'red--text title' : 'title'
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totNotYetIn))]), _vm._v(" "), _c('span', {
      staticClass: "grey--text"
    }, [_vm._v("|")]), _vm._v(" "), _c('span', {
      class: _vm.shiftSummary[shift.shift_id].totNotYetOut ? 'warning--text title' : 'title'
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totNotYetOut))])])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey"
  }, [_c('div', {
    staticClass: "title white--text"
  }, [_vm._v("Key Staffs [" + _vm._s(_vm.lCurrentShift) + "]")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.keyStaffHeadSm : _vm.keyStaffHead,
      "items": _vm.keyStaffs,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.attendance ? '' : 'red--text'
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(_vm.handy.formatDBDate(props.item.att_dt)))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_mobile))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.attendance ? props.item.attendance : 'Pending'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: 'pa-3' + (props.item.sby_temp_staff_name ? ' red' : '')
        }, [_vm._v(_vm._s(props.item.standby))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_in ? _vm.handy.formatDBDateTime(props.item.check_in) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_out ? _vm.handy.formatDBDateTime(props.item.check_out) : '-'))]) : _vm._e()])]
      }
    }], null, false, 2088263442)
  })], 1)], 1)], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tab-item', {
    key: 1,
    attrs: {
      "value": "tab-1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "grey lighten-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vendor",
      "items": _vm.vendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "placeholder": "All",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filter.vendor_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "vendor_list", $$v)
      },
      expression: "filter.vendor_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Services",
      "items": _vm.roles,
      "item-text": "staff_role",
      "item-value": "staff_role_id",
      "placeholder": "All",
      "hide-details": "",
      "multiple": "",
      "clearable": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filter.role_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "role_list", $$v)
      },
      expression: "filter.role_list"
    }
  })], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('v-flex', {
    attrs: {
      "sm1": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDt),
      callback: function($$v) {
        _vm.dlgFromDt = $$v
      },
      expression: "dlgFromDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDt.save(_vm.filter.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDt),
      callback: function($$v) {
        _vm.dlgToDt = $$v
      },
      expression: "dlgToDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDt.save(_vm.filter.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refreshAttReport(_vm.lRep.agreedHeadCount, 'Billable')
      }
    }
  }, [_vm._v("\n      Go\n    ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Attendance Summary")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("For period of " + _vm._s(_vm.filter.rep_days) + " days")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-0",
    attrs: {
      "xs7": "",
      "sm3": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.refreshAttReport(null, chip)
        }
      }
    }, [_vm._v("\n              " + _vm._s(chip) + "\n            ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "py-1 my-0",
    attrs: {
      "xs5": "",
      "sm3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "py-1 my-0",
    staticStyle: {
      "text-align": "center",
      "font-size": "8px"
    },
    attrs: {
      "label": "Show Agreed",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshAttReport(_vm.lRep.agreedHeadCount, _vm.enableChip)
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v("Show Agreed")])]
      },
      proxy: true
    }], null, false, 3162163078),
    model: {
      value: (_vm.lRep.agreedHeadCount),
      callback: function($$v) {
        _vm.$set(_vm.lRep, "agreedHeadCount", $$v)
      },
      expression: "lRep.agreedHeadCount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.lRep.agreedHeadCount ? _vm.repHeadCountSm : _vm.repHeadSm,
      "items": _vm.attReport,
      "title": "Attendance Summary",
      "fontsize": 8,
      "subtitle": (_vm.filter.vendor_list && _vm.filter.vendor_list.length ? _vm.filter.vendor_list.map(function (rec) { return rec.vendor_name; }).join() + ' - ' : '') + (_vm.filter.role_list && _vm.filter.role_list.length ? _vm.filter.role_list.map(function (rec) { return rec.staff_role; }).join() : '') + (' [' + _vm.handy.formatDate(_vm.filter.from_dt) + ' to ' + _vm.handy.formatDate(_vm.filter.to_dt) + '] (' + _vm.filter.rep_days + ' days)')
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": (_vm.$vuetify.breakpoint.smAndUp ? (_vm.lRep.agreedHeadCount ? _vm.repHeadCountSm : _vm.repHeadSm) : _vm.repHead),
      "items": _vm.attReport,
      "hide-actions": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_present))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2 accent lighten-3 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_contracted))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2 green lighten-3 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_billable))])])]
      }
    }], null, false, 1416169601)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('span', {
    staticClass: "subtitle font-weight-bold"
  }, [_vm._v("Attendance Detail")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pt-0",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": true,
      "row": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshAttReportDet(_vm.filter.billable)
      }
    },
    model: {
      value: (_vm.filter.det_type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "det_type", $$v)
      },
      expression: "filter.det_type"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "date"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("Calendar View")])]
      },
      proxy: true
    }], null, false, 1605266347)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Staff View",
      "value": "staff"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("Staff View")])]
      },
      proxy: true
    }], null, false, 1799492703)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Timesheet",
      "value": "timesheet"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("Timesheet")])]
      },
      proxy: true
    }], null, false, 1516345582)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "inOutSheet"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("In/Out Sheet")])]
      },
      proxy: true
    }], null, false, 2393189085)
  })], 1)], 1), _vm._v(" "), (_vm.attNonBill.tot_nonbillable_staff > 0) ? _c('v-flex', {
    staticClass: "pt-3 text-xs-right",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.filter.billable === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.refreshAttReportDet(chip)
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by role, name, etc.' : 'Search',
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.filter.det_type === 'staff' ? _vm.repDetStaffHeadSm : _vm.repDetCalHeadSm,
      "items": _vm.attReportDet,
      "title": "Attendance Detail",
      "subtitle": (_vm.filter.vendor_list && _vm.filter.vendor_list.length ? _vm.filter.vendor_list.map(function (rec) { return rec.vendor_name; }).join() + ' - ' : '') + (_vm.filter.role_list && _vm.filter.role_list.length ? _vm.filter.role_list.map(function (rec) { return rec.staff_role; }).join() : '') + (' [' + _vm.handy.formatDate(_vm.filter.from_dt) + ' to ' + _vm.handy.formatDate(_vm.filter.to_dt) + '] (' + _vm.filter.rep_days + ' days)'),
      "landscape": _vm.filter.det_type !== 'staff',
      "fontsize": _vm.filter.det_type === 'timesheet' ? 6 : 7,
      "cellpadding": _vm.filter.det_type === 'timesheet' ? 0.25 : 1,
      "legend": "P-Present, W-Weeklyoff, H-Holiday, HD-Half Day, S-Standby, O-Overtime, L-Leave, A-Absent, Billable=P+W+H+S/O+L"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.filter.det_type === 'staff' ? _vm.repDetStaffHeadSm : _vm.repDetCalHeadSm) : (_vm.filter.det_type === 'staff' ? _vm.repDetStaffHead : _vm.repDetCalHeadSm),
      "items": _vm.attReportDet,
      "hide-actions": "",
      "search": _vm.search,
      "sort-by": ['staff_role', 'staff_name'],
      "multi-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.staff_role))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.vendor_emp_id))]) : _vm._e(), _vm._v(" "), _vm._l((props.item.calendar), function(calday, i) {
          return _c('td', {
            key: i,
            class: (_vm.filter.det_type === 'timesheet' ? 'px-1' : 'pa-0') + ' text-xs-center ' + (calday.attendance.includes('P') ? 'green' : calday.attendance.includes('A') ? 'red' : calday.attendance.includes('W') ? 'yellow' : (calday.attendance.includes('CL') || calday.attendance.includes('SL') || calday.attendance.includes('EL')) ? 'orange' : calday.attendance.includes('HD') ? 'green lighten-2' : calday.attendance.includes('H') ? 'blue' : !calday.attendance ? 'red lighten-4' : 'grey lighten-2')
          }, [(calday.attendance) ? _c('span', {
            class: calday.attendance === '-' ? 'title' : ''
          }, [_c('b', [_vm._v(_vm._s(calday.attendance))])]) : _c('span', {
            staticClass: "display-1 red--text"
          }, [_vm._v(".")]), _vm._v(" "), (calday.att_detail) ? _c('span', {
            staticClass: "caption"
          }, [_c('br'), _vm._l((calday.att_detail.split('\n')), function(line, i) {
            return _c('span', {
              key: i
            }, [_vm._v(_vm._s(line)), _c('br')])
          })], 2) : _vm._e()])
        }), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_present))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), (_vm.filter.det_type === 'staff') ? _c('td', {
          staticClass: "pa-2 accent lighten-3 pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_contracted))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2 green lighten-3 pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_billable))])], 2)]
      }
    }], null, false, 3429107591)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'att-det') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-1"
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 pb-0"
  }, [_vm._v("\n          Attendance (" + _vm._s(_vm.lCurrentShift) + ")\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'view', _vm.search = ''
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.attHeadSm,
      "items": _vm.shiftSummary[_vm.lCurrentShiftId].detail,
      "title": "Attendance Details",
      "subtitle": _vm.lCurrentFrom + ' to ' + _vm.lCurrentTo + ' (' + _vm.lCurrentShift + ')',
      "landscape": true
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.attNonBill.tot_nonbillable_staff > 0) ? _c('v-flex', {
    class: _vm.attNonBill.tot_nonbillable_staff > 0 ? 'pt-3 pb-0' : '',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.filter.billable === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.refreshNonBillAttReportDet(chip)
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.attHeadSm : _vm.attHead,
      "items": _vm.filter.billable === 'Billable' ? _vm.shiftSummary[_vm.lCurrentShiftId].detail : _vm.nonBillshiftSummary[_vm.lCurrentShiftId],
      "hide-actions": "",
      "search": _vm.search,
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: ((props.item.attendance !== 'Absent' && props.item.attendance !== 'Weekly Off' && props.item.attendance !== 'Holiday') || (props.item.standby || props.item.sby_temp_staff_name)) && props.item.check_in && !props.item.check_out ? 'warning--text' : (props.item.attendance ? '' : 'red--text'),
          on: {
            "click": function($event) {
              return _vm.prepareEditDet(props.item)
            }
          }
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(_vm.handy.formatDBDate(props.item.att_dt)))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_name) + " (" + _vm._s(props.item.vendor_emp_id) + ")")]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.attendance ? props.item.attendance : 'Pending'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: 'pa-3' + (props.item.sby_temp_staff_name ? ' red' : '')
        }, [_vm._v(_vm._s(props.item.standby))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_in ? _vm.handy.formatDBDateTime(props.item.check_in) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_out ? _vm.handy.formatDBDateTime(props.item.check_out) : '-'))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.effective_work_hours ? props.item.effective_work_hours : '-'))])])]
      }
    }], null, false, 2916834934)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'att-log') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-1"
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 pb-0"
  }, [_vm._v("\n          Attendance Log (" + _vm._s(_vm.handy.startWithUpper(_vm.filter.current_period)) + ")\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'view', _vm.search = ''
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.filterOfflineDev ? _vm.offlineDevHeadSm : _vm.attLogHeadSm,
      "items": _vm.filterOfflineDev ? _vm.offlineDevList : _vm.attLog,
      "title": "Attendance Log",
      "subtitle": _vm.lCurrentFrom + ' to ' + _vm.lCurrentTo
    }
  })], 1), _vm._v(" "), (_vm.offlineDevList.length) ? _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    class: 'ma-0 pa-0' + (_vm.filterOfflineDev ? ' info white--text' : ' red--text'),
    attrs: {
      "disabled": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.filterOfflineDev = !_vm.filterOfflineDev
      }
    }
  }, [_vm._v(_vm._s(_vm.offlineDevList.length) + " offline deviations")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.filterOfflineDev ? _vm.offlineDevHeadSm : _vm.attLogHeadSm) : (_vm.filterOfflineDev ? _vm.offlineDevHead : _vm.attLogHead),
      "items": _vm.filterOfflineDev ? _vm.offlineDevList : _vm.attLog,
      "hide-actions": "",
      "search": _vm.search,
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp || !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.log_action))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.log_mode_and_loc))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDBDateTime(props.item.log_time)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.staff_role))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.remark))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.approved_by))]) : _vm._e(), _vm._v(" "), (_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.offline_deviation))]) : _vm._e()])]
      }
    }], null, false, 1004482204)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dlgAttDet),
      callback: function($$v) {
        _vm.dlgAttDet = $$v
      },
      expression: "dlgAttDet"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.lAttDet.staff_name + ' (' + _vm.lCurrentShift + ')') + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Shift",
      "items": _vm.shifts,
      "item-value": "shift_id",
      "item-text": "shift_abbr",
      "error-messages": _vm.shiftNotRight && !_vm.shiftOverride ? 'Shift is not right based on check-in time' : ''
    },
    model: {
      value: (_vm.lAttDet.shift_id),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "shift_id", $$v)
      },
      expression: "lAttDet.shift_id"
    }
  })], 1), _vm._v(" "), (_vm.shiftNotRight) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Proceed with above shift"
    },
    model: {
      value: (_vm.shiftOverride),
      callback: function($$v) {
        _vm.shiftOverride = $$v
      },
      expression: "shiftOverride"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Attendance",
      "items": ['Present', 'Absent', 'Weekly Off', 'Half Day', 'Holiday', 'Present + OT', 'Weekly Off + OT', 'Holiday + OT', 'Present + RL', 'Casual Leave', 'Earned Leave', 'Sick Leave', 'Comp Off'],
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.loadNonBillStaffasSby(_vm.lAttDet)
      }
    },
    model: {
      value: (_vm.lAttDet.attendance),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "attendance", $$v)
      },
      expression: "lAttDet.attendance"
    }
  })], 1), _vm._v(" "), (_vm.lAttDet.attendance === 'Absent' || (_vm.lAttDet.attendance && _vm.lAttDet.attendance.includes('Leave')) || _vm.lAttDet.attendance === 'Weekly Off' || _vm.lAttDet.attendance === 'Holiday') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Standby staff",
      "items": _vm.vendorStandby,
      "item-text": "emp_name_and_id",
      "item-value": "vendor_emp_id",
      "clearable": ""
    },
    model: {
      value: (_vm.lAttDet.sby_vendor_emp_pair),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "sby_vendor_emp_pair", $$v)
      },
      expression: "lAttDet.sby_vendor_emp_pair"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lAttDet.attendance === 'Absent' || (_vm.lAttDet.attendance && _vm.lAttDet.attendance.includes('Leave')) || _vm.lAttDet.attendance === 'Weekly Off' || _vm.lAttDet.attendance === 'Holiday') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Temporary Staff",
      "hint": "Staff deployed temporarily in case",
      "persistent-hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.lAttDet.sby_temp_staff_name),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "sby_temp_staff_name", $$v)
      },
      expression: "lAttDet.sby_temp_staff_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckIn",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkInDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInDt", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckIn),
      callback: function($$v) {
        _vm.dlgCheckIn = $$v
      },
      expression: "dlgCheckIn"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Check-in",
      "append-icon": "event",
      "readonly": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkInDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInDt", $$v)
      },
      expression: "lAttDet.checkInDt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.handy.formatDBDate(_vm.lAttDet.checkInMinDt),
      "max": _vm.handy.formatDBDate(_vm.lAttDet.checkInMaxDt)
    },
    on: {
      "change": function($event) {
        return _vm.GetCheckOutDate(_vm.lAttDet.checkInDt)
      }
    },
    model: {
      value: (_vm.lAttDet.checkInDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInDt", $$v)
      },
      expression: "lAttDet.checkInDt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckIn = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckIn.save(_vm.lAttDet.checkInDt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckInTime",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkInTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInTime", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckInTime),
      callback: function($$v) {
        _vm.dlgCheckInTime = $$v
      },
      expression: "dlgCheckInTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": ""
    },
    on: {
      "input": function($event) {
        _vm.lAttDet.checkInTime = null
      }
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkInTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInTime", $$v)
      },
      expression: "lAttDet.checkInTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lAttDet.checkInTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInTime", $$v)
      },
      expression: "lAttDet.checkInTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckInTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckInTime.save(_vm.lAttDet.checkInTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckOut",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkOutDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutDt", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckOut),
      callback: function($$v) {
        _vm.dlgCheckOut = $$v
      },
      expression: "dlgCheckOut"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Check-out",
      "append-icon": "event",
      "readonly": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkOutDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutDt", $$v)
      },
      expression: "lAttDet.checkOutDt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.lAttDet.checkInDt,
      "max": _vm.handy.formatDBDate(_vm.lAttDet.checkOutMaxDt)
    },
    model: {
      value: (_vm.lAttDet.checkOutDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutDt", $$v)
      },
      expression: "lAttDet.checkOutDt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckOut = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckOut.save(_vm.lAttDet.checkOutDt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckOutTime",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkOutTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutTime", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckOutTime),
      callback: function($$v) {
        _vm.dlgCheckOutTime = $$v
      },
      expression: "dlgCheckOutTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": ""
    },
    on: {
      "input": function($event) {
        _vm.lAttDet.checkOutTime = null
      }
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkOutTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutTime", $$v)
      },
      expression: "lAttDet.checkOutTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lAttDet.checkOutTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutTime", $$v)
      },
      expression: "lAttDet.checkOutTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckOutTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckOutTime.save(_vm.lAttDet.checkOutTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), (this.att_dev_type === 'FC Device' && (_vm.lAttDet.attendance === 'Present' || _vm.lAttDet.attendance === 'Half Day' || _vm.lAttDet.attendance === 'Present + OT' || _vm.lAttDet.attendance === 'Weekly Off + OT' || _vm.lAttDet.attendance === 'Holiday + OT' || _vm.lAttDet.attendance === 'Present + RL' || _vm.lAttDet.attendance === 'Casual Leave' || _vm.lAttDet.attendance === 'Earned Leave' || _vm.lAttDet.attendance === 'Sick Leave' || _vm.lAttDet.attendance === 'Comp Off')) ? _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Reason for manual Entry",
      "maxlength": "25",
      "rules": [_vm.rules.minimum],
      "hint": "Max 30 characters "
    },
    model: {
      value: (_vm.lAttDet.remark),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "remark", $$v)
      },
      expression: "lAttDet.remark"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Approved By",
      "maxlength": "25",
      "rules": [_vm.rules.minimum],
      "hint": "Max 15 characters "
    },
    model: {
      value: (_vm.lAttDet.approved_by),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "approved_by", $$v)
      },
      expression: "lAttDet.approved_by"
    }
  })], 1) : (this.att_dev_type !== 'FC Device') ? _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Remarks",
      "hint": "Max 30 characters "
    },
    model: {
      value: (_vm.lAttDet.remark),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "remark", $$v)
      },
      expression: "lAttDet.remark"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dlgAttDet = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": _vm.beingSaved || !_vm.lAttDet.attendance ? 'grey' : 'accent',
      "disabled": _vm.beingSaved || !_vm.lAttDet.attendance
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "40%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "info"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6c8faa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Attendance.vue
// module id = 919
// module chunks = 6